import $ from "jquery";

/**
 * Sticky bar
 *
 * De balk ligt bij landing over de onderkant van de hero en plakt daarna aan de onderkant van het
 * venster. Dat omslagpunt is niet met `position: sticky` te maken — sticky-bottom trekt een element
 * juist omhóóg vóórdat het in beeld komt, precies het omgekeerde — dus zet deze component de klasse
 * `s_pinned` zodra de flow-plek van de balk achter het vastgeplakte menu is verdwenen.
 *
 * Hij plakt ook aan de ándere kant: is de hero hoger dan het venster, dan ligt zijn flow-plek onder
 * de vouw en zou de bezoeker het zoekveld pas na scrollen te zien krijgen. Zolang die plek onder de
 * onderrand van het venster ligt, plakt de balk dus ook. Er zit geen sprong tussen de twee standen:
 * het omslagpunt is precies de scrollpositie waar de flow-plek de onderrand van het venster raakt,
 * en daar staat de balk in beide standen op dezelfde plek.
 *
 * ⚠️ Een IntersectionObserver kan dit niet zien. De flow-plek is 0px hoog (zie de SCSS), en voor een
 * doel zonder oppervlak blijft `isIntersecting` altijd `false` — er komt dus nooit een tweede
 * callback om op te reageren. Vandaar de scroll-handler, met een rAF ertussen zodat er per frame
 * hoogstens één meting is.
 *
 * De flow-plek zelf beweegt niet mee als de balk vastplakt (0px hoog, de balk zweeft eruit), dus de
 * meting blijft geldig en er ontstaat geen heen-en-weer.
 */

const PINNED_CLASS = "s_pinned";

/**
 * Hoogte van het vastgeplakte menu plus de (vaste) WP-adminbalk, in pixels. Zonder die marge zou de
 * balk eerst een menuhoogte lang onzichtbaar achter het menu hangen voordat hij onderaan verschijnt.
 */
function getMenuOffset() {
    const styles = getComputedStyle(document.documentElement);
    const menu = parseFloat(styles.getPropertyValue("--sb-menu-height-large-up"));
    const adminBar = parseFloat(
        styles.getPropertyValue("--wp-admin--admin-bar--height")
    );

    return (
        (Number.isFinite(menu) ? menu : 56) +
        (Number.isFinite(adminBar) ? adminBar : 0)
    );
}

$(function () {
    const bar = document.querySelector("[data-sticky-bar]");

    if (!bar) {
        return;
    }

    let offset = getMenuOffset();
    let frame = null;

    function update() {
        frame = null;

        const top = bar.getBoundingClientRect().top;
        const isBehindMenu = top <= offset;
        const isBelowFold = top > window.innerHeight;

        bar.classList.toggle(PINNED_CLASS, isBehindMenu || isBelowFold);
    }

    function schedule() {
        if (frame === null) {
            frame = requestAnimationFrame(update);
        }
    }

    window.addEventListener("scroll", schedule, { passive: true });
    window.addEventListener("resize", () => {
        offset = getMenuOffset();
        schedule();
    });

    update();
});
